export const priceFormat = (value, decimals = 4)=>{
  return parseFloat(value).toLocaleString('pt-BR', {
    minimumFractionDigits: 4,
    style: 'currency',
    currency: 'BRL'
  });
};